<div class="d-flex flex-column flex-column-fluid">
  <div class="container-fluid">
    <div class="container-fluid mb-4">
      <div class="row">
        <div class="col">
          <div class="container-fluid mt-1 px-0">
            <!-- Patient Header Informations -->
            <div class="card">
              <div class="container-fluid pb-4">
                <div class="row align-items-center py-3 pb-0">
                  <div class="col-md-4 pb-2 pt-4 ps-8">
                    <div class="card-subtitle fw-medium">
                      <h5 class="card-subtitle">
                        {{ caseDetailHeader?.name || "-" }}
                        {{ caseDetailHeader?.lastName || "-" }},
                        {{ caseDetailHeader?.age }},
                        {{ caseDetailHeader?.gender[0] || "-" }},
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-diabetes-forms [newPatientId]="newPatientId" [caseId]="caseId"></app-diabetes-forms>
  </div>
</div>
